import React from "react";
import { Outlet } from "react-router";

export interface ICustomerProfilePageProps {}

const CustomerProfilePage: React.FC<ICustomerProfilePageProps> = (_props) => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default CustomerProfilePage;
